import { render, staticRenderFns } from "./ContactRemove.vue?vue&type=template&id=350a89a8"
import script from "./ContactRemove.vue?vue&type=script&lang=js"
export * from "./ContactRemove.vue?vue&type=script&lang=js"
import style0 from "./ContactRemove.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports